import { render, staticRenderFns } from "./inlet.vue?vue&type=template&id=28529c2a&scoped=true&"
import script from "./inlet.vue?vue&type=script&lang=js&"
export * from "./inlet.vue?vue&type=script&lang=js&"
import style0 from "./inlet.vue?vue&type=style&index=0&id=28529c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28529c2a",
  null
  
)

export default component.exports